import { Pipe, PipeTransform } from '@angular/core';
import messages from 'locale/messages.pt';

@Pipe({ name: 'message' })
export class MessagesPipe implements PipeTransform {
  transform(value: string) {
    return messages[value] || `{ Mensagem não encontrada para '${value}' }`;
  }
}
